//#region Imports Packages and Libs

import { Component, Vue } from "vue-facing-decorator";
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import Chat from "../components/chat.vue";
import Loader from "../components/loader.vue";
import Error from "../components/error.vue";
import Banner from "../components/banner.vue";
import ModalCarousel from "../components/modal-carousel.vue";
import { SignalrHandler } from "../extra/signalr_handler";
import { STORE_MUTATION } from "../enums/store_mutation";
import { getUserId } from "../helpers/get_user_id";
import { store } from "../store/store";
import { getQueryStringValue } from "../helpers/get_querystring_value";
import { Util } from "../util";
import { installJquery } from "../helpers/install_jquery";
import { installSignalr } from "../helpers/install_signalr";
import { __vueEvent, __maintainStateTime, __maintainState } from "../constant";
import { ConfigLoader } from "../helpers/config_loader";
import { CACHE_ID_TYPE, CONSTANTS, EVENTS, MESSAGE_TYPE, SIGNALR_STATUS } from "../enums";
import { IConfig } from "../interfaces/config";
import { StorageHelper, addUserMessage, getMessageFromServer, isLoadInIFrame, sanitizeToText } from "../helpers";
import { ChatService } from "../service/chat_service";
import { isMobile } from "../helpers/is_mobile";
import { IMessage } from "../interfaces";
import { isFirefox } from "../helpers/get-browser-type";
import { navigateToTop, navigateToBottom } from "../helpers/a11y/keyboard-navigation";
import { isCtrlDownArrow, isCtrlUpArrow } from '../helpers/a11y/utils';
import { BottomNavigationState, TopNavigationState } from '../types';

//#endregion

declare var satisfiLabsGLobal;

@Component({
  components: { Header, Footer, Chat, Loader, Error, Banner, ModalCarousel },
})
export default class Main extends Vue {
    //#region Class properties will be component data
    hideIFrameHeader = true;
    hideTagLine = false;
    //#endregion

    //#region Computed Properties

    get isMobileActive() {
      return isMobile.any() || this.$store.state.isIFrameLoaded;
    }

    get isHideTitleBar() {
      return this.$store.state.isHideTitleBar || false;
    }

    get isConfigurationLoaded() {
      return this.$store.state.isConfigurationLoaded || false;
    }

    get errorMessage() {
      return this.$store.state.errorMessage || "";
    }

    get isShowHeaderInIframe() {
      return this.$store.state.isShowHeaderInIframe || false;
    }

    get hideHeader() {
      //@ts-ignore
      return this.$store.state.hideHeader || false;
    }

    get shouldShowBanner() {
      return this.$store.state.shouldShowBanner || false;
    }

    get isIFrameLoaded() {
      return this.$store.state.isIFrameLoaded || false;
    }

    get enableMessageNavigation() {
      return this.$store.state.enableMessageNavigation || false;
    }

    get carouselModalDetail() {
      return this.$store.state.carouselModalDetail;
    }

    get carouselModalList() {
      return this.$store.state.carouselModalList;
    }

    /**
     * Determines if the Webchat is loaded within an iframe (embedded) and is not being
     * accessed from a actual mobile device.
     */
    get isEmbeddedNonMobile(): boolean {
      try {
        return this.$store.state.isIFrameLoaded && !isMobile.any();
      } catch {
        return false;
      }
    }

    //#endregion

    async mounted() {
        this.windowEventListener();
        console.log("Main component called ");
        window.parent.postMessage({
            event_id: 'getSatisfiMessageMetaInfo'
        }, "*");
        const service = new ChatService();
        const awsConfigs = await service.getAWSConfig('0');
        store.commit(STORE_MUTATION.SetAWSServerURL, awsConfigs.awsServerURL);
        store.commit(STORE_MUTATION.SetAWSImageLogoPath, awsConfigs.awsImageLogoPath);
        store.commit(STORE_MUTATION.SetAWSPopupConfigPath, awsConfigs.awsPopupConfigPath);
        store.commit(STORE_MUTATION.SetAWSThemeFilePath, awsConfigs.awsThemeFilePath);

        store.commit(STORE_MUTATION.SetSatisfiURL, satisfiLabsGLobal.WebChatAddress);

        store.commit(STORE_MUTATION.SetPageReferralUrl, document.referrer);
        this.listenEvents();
        await this.setUserId();
        await this.setCFHeader();
        await new ConfigLoader().load();
    }

    windowEventListener() {

        //Call from Iframe to web chat.
        if (window.addEventListener) {
            window.addEventListener("message", (event) => {
                switch (event.data.event_id) {
                    case 'satisfiMessageMetaInfo':

                        if(store.state.popupId == "0"){
                                const chatService = new ChatService();
                                //chatService.logPageInformation(event.data.data.popupId, 16);
                        }

                        store.commit(STORE_MUTATION.SetPopupId, event.data.data.popupId);
                        store.commit(STORE_MUTATION.SetParentSiteUrl, event.data.data.parentSiteUrl);
                        store.commit(STORE_MUTATION.SetParentSiteReferralUrl, event.data.data.parentSiteReferralUrl);

                        break;

                    case 'satisfiLocationChangeInfo':
                        store.commit(STORE_MUTATION.SetParentSiteUrl, event.data.data.parentSiteUrl);
                        break;

                    case 'satisfiFocusFirstMessage':
                        this.focusFirstElementOFChatPage();
                        break;
                    case 'satisfiFocusLastElement':
                        this.focusLastElementOFChatPage();
                        break;
                    case 'unhideInputContainer':
                        store.commit(STORE_MUTATION.SetDisableInput, false);
                        store.commit(STORE_MUTATION.SetDefaulthideInputContainerSetting, false);
                        break;
                    case 'satisfiFocusInputField':
                        if (typeof jQuery !== 'undefined') {
                            jQuery(`.${this.$store.state.prefixClassName}textInput`).focus();
                        }
                        break;
                    case 'satisfiSendMessage':
                        this.addMessageInIframeFromGlobal(event.data.data.input, event.data.data.inputHidden);
                        break;
                    case 'satisfiBrowserPopupBlockReport':
                        if (!store.state.shouldShowBanner) {
                            store.commit(STORE_MUTATION.SetBannerText, "Browser is blocking urls on this site.");
                            store.commit(STORE_MUTATION.SetShouldShowBanner, true);
                            setTimeout(() => {
                                if (store.state.bannerText !== "Connecting...") {
                                    store.commit(STORE_MUTATION.SetShouldShowBanner, false);
                                }
                            }, 5000);
                        }
                        break;
                    case 'satisfiCloseIFrameForRemoteUrl':
                        var ifrm = document.getElementById("remote_browser_target");
                        if (ifrm) {
                            ifrm.remove();
                        }
                        break;
                    case 'satisfiTilesIsOpened':
                        // SD-1671
                        // Now we know that tile is opened by a client.
                        // We can now update the flag value, so that we can access it other components
                        store.commit(STORE_MUTATION.SetIsTilesOpenedInIframe, true);
                        const service = new ChatService();
                        service.logPageInformation(event.data.data.tileId, 17);
                        break;
                    case 'onRedirectURL':
                        this.RedirectURLFromChild(event.data.data);
                        break;
                    case 'satisfi_client_site_language':
                        // SD-7070: Receive the language from the client site and set it in the store
                        const language = this.getPostMessageData(event);
                        store.commit(STORE_MUTATION.SetClientSiteLanguage, language);
                        break;
                }
            }, false);
						window.addEventListener('keydown', this.HandleKeyboardNavigation.bind(this));
        }

        this.SetPlatformInfo();
        this.DocumentEventListener();
    }

    /**
     * SD-5173: Redirects the URL from the child iframe to the parent iframe.
     * @param data - The props passed from the child iframe to the parent iframe.
     */
    RedirectURLFromChild(data: any){
      try {
        // Get all the props passed from child iframe to parent iframe
        const href = data.href || "";
        const target = data.target || "";
        const hideInChatBackButton = data.hideInChatBackButton || false;

        // Check if the current window is loaded in an iframe
        if (isLoadInIFrame()) {
          // Pass the same information to the parent iframe
          window.parent.postMessage({
            event_id: 'onRedirectURL',
            data: { href: href, target: target, hideInChatBackButton: hideInChatBackButton }
          }, "*");
        } else {
          // Redirect the URL to the new page in a new tab
          if (target === "_blank") {
            window.open(href, target, "noopener noreferrer");
          }
        }
      } catch (ex) {
        console.log("[main.ts] An error has occurred \n-> Inside RedirectURLFromChild -> Error: ", ex);
      }
    }

		/**
		 * This is used to clean up the event listeners before the component is destroyed.
		 */
		beforeDestroy(): void {
			window.removeEventListener('keydown', this.HandleKeyboardNavigation.bind(this));
		}

		/**
		 * Handles keyboard navigation events for the chat interface
		 * @param event The keyboard event
		 * @remarks
		 * This method implements keyboard shortcuts for navigating between the first message and the input box:
		 * - CTRL+Up Arrow: Navigate to the first message or interactive element
		 * - CTRL+Down Arrow: Navigate to the input box
		 * It respects the enableMessageNavigation configuration setting.
		 */
		HandleKeyboardNavigation(event: KeyboardEvent): void {
			try {
				// Only handle keyboard events if a modal is not open
				if (
					store.state.showAdminLoginModal ||
					store.state.showConsentModal ||
					store.state.showTranscriptModal ||
					store.state.carouselModalDetail
				) {
					return;
				}

				// Check for CTRL+Up Arrow (Navigate to top)
				if (isCtrlUpArrow(event)) {
					event.preventDefault();
					const topNavState: TopNavigationState = {
						prefixClassName: store.state.prefixClassName,
						isIFrameLoaded: store.state.isIFrameLoaded,
						isTilesOpened: store.state.isTilesOpenedInIframe,
						enableMessageNavigation: store.state.enableMessageNavigation
					}
					navigateToTop(topNavState);
					return;
				}

				// Check for CTRL+Down Arrow (Navigate to bottom)
				if (isCtrlDownArrow(event)) {
					event.preventDefault();
					const bottomNavState: BottomNavigationState = {
						prefixClassName: store.state.prefixClassName,
						isIFrameLoaded: store.state.isIFrameLoaded,
						isTilesOpened: store.state.isTilesOpenedInIframe,
						disableInput: store.state.disableInput
					};
					navigateToBottom(bottomNavState);
					return;
				}
			} catch (ex) {
				console.log("[main.ts] An error has occurred \n-> Inside handleKeyboardNavigation -> Error: ", ex);
			}
		}

    /**
     * Extracts the language data from a PostMessage event
     * @param event - The PostMessage event object containing potential language data
     * @returns The language value if found in event.data.data.language, null otherwise
     * @remarks
     * This method safely handles the extraction of language data from a PostMessage event.
     * It performs null checking on the event object and its nested properties.
     */
    getPostMessageData(event: any): string | null {
      let language = null;
      try {
        if (event && event.data && event.data.data
          && typeof event.data.data.language !== 'undefined') {
          language = event.data.data.language;
        }
      } catch (e) {
        language = null;
      }
      return language;
    }

    /**
     * Gets the tagline content to be displayed.
     * Retrieves the tagline text from the page configuration if available,
     * otherwise returns the default tagline text.
     *
     * @returns {string} The tagline text to be displayed
     */
    get taglineContent(): string {
      const pageConfig = this.$store.state.pageConfig;
      const taglineText = pageConfig ? pageConfig.taglineText : "";
      return taglineText || CONSTANTS.POWERED_BY;
    }

	get taglineUrl(): string {
		const taglineUrl = this.$store.state.taglineUrl;
		return taglineUrl || CONSTANTS.TAGLINE_URL;
	}

    /**
     * 628 - This method is used to set a class to body for mobile devices only.
     * It is used to fix a bug where footer was getting hidden sometimes when virtual keyboard opens in iOS
     */
    SetPlatformInfo() {
        try {

            let userAgentString = navigator.userAgent.toLowerCase();
            let chromeIndex = userAgentString.indexOf("chrome");
            let safariIndex = userAgentString.indexOf("safari");

            if (document.body != null && safariIndex != -1 && isMobile.any()) {
                if (chromeIndex > -1) {
                    document.body.classList.add("satisfi_chrome");
                } else {
                    document.body.classList.add("satisfi_safari");

                    // Get iOS version and add that version as a class
                    let ver = this.GetiOSVersion();
                    if (ver >= 15) {
                        document.body.classList.add("satisfi_safari_iOS15");
                    }
                }
            }

            // SD-5847: Check if the chat page is opened in an iOS WK Webview
            // Refrence: https://stackoverflow.com/a/74619842/1823841
            const standalone = "standalone" in navigator && navigator["standalone"];
            const safari = /safari/.test(userAgentString);
            const ios = /iphone|ipod|ipad|macintosh/.test(userAgentString);
            const ios_ipad_webview = ios && !safari;

            // Add the class "ios_webview" to the body if the chat page is opened in an iOS WK Webview
            if (ios && !standalone && !safari) {
              document.body.classList.add("satisfi_ios_webview");
            }

        } catch (ex) {
            //var errorObj = { Page: 'main.ts', MethodName: 'SetPlatformInfo', Message: ex.message };
            //console.log(errorObj);
        }
    }

    /**
     * This method is used to Detect the iOS version
     * WEBAPPS-954
     */
    GetiOSVersion() {
        try {
            var agent = navigator.userAgent
            if (/(iPhone|iPod|iPad)/i.test(agent)) {
                var v = agent.match(/OS (\d+)_(\d+)_?(\d+)?/);
                return (v && v.length > 1) ? Number(v[1]) : 0;
            }
            return 0;
        } catch (ex) {
            return 0;
        }
    }

    timer = null;
    /**
     * This method is used to close the virtual keyboard in iOS on clicking outside the textarea.
     */
    DocumentEventListener() {
        try {
            let vm = this;
            if (isMobile.iOS() && document.addEventListener) {
                document.addEventListener("touchend", function (event) {
                    let target = event.target as HTMLElement;
                    if (!target) return;
                    let tagName = target.tagName;
                    if (tagName === "TEXTAREA") return;

                    // Check if the target is an input field and a text field
                    // If it is a text field, then do not close the virtual keyboard in iOS
                    if (tagName === "INPUT") {
                        let inputElement = target as HTMLInputElement;
                        if (["text", "email", "number", "password", "search", "tel", "url"].includes(inputElement.type)) {
                            return;
                        }
                    }

                    vm.timer = setTimeout(function () {
                        if (document.activeElement) {
                            (document.activeElement as HTMLElement).blur();
                        }
                        clearTimeout(vm.timer);
                    }, 300);
                });
            }

            /**
             * Captures the text selected by the user and modifies it before copying to the clipboard.
             * Removes the text "Bot says:" or "I say:" from the copied text to avoid including it in the clipboard.
             *
             * @param {ClipboardEvent} event - The event object representing the clipboard event.
             */
            function captureClipboard(event) {
              try {
                const selection = window.getSelection();
                if (selection) {
                  let copiedText = selection.toString();
                  if (!Util.isNullOrEmpty(copiedText)) {
                    //@ts-ignore
                    const clipboardData = event.clipboardData || window.clipboardData;
                    if (clipboardData) {
                      event.preventDefault();
                      // Remove the text "Bot says:" or "I say:" from the copied text
                      // This is done to avoid copying the text "Bot says:" or "I say:" in the clipboard
                      copiedText = copiedText.replace(/(Bot says:|I say:)\s*\n?/gi, '');
                      clipboardData.setData('text/plain', copiedText);
                    }
                  }
                }
              } catch (ex) {
                //console.log(ex);
              }
            }

            // SD-5446: Handle the case when user copy the text from the chat window and paste it in slack app.
            // We do not need this fix for Firefox browser as it is already handled by the browser.
            if (document.addEventListener && !isFirefox()) {
              document.addEventListener("copy", captureClipboard);
            }
        } catch (error) { }
    }

    addMessageInIframeFromGlobal(input = '', inputHidden = '') {
        input = sanitizeToText(input);
        if (input != '') {
            addUserMessage(input, true, (inputHidden == '1' ? true : false));
        }
    }

    focusFirstElementOFChatPage() {
        try {
            let webchatSectionBtn = jQuery(`.${this.$store.state.prefixClassName}standalone section .${this.$store.state.prefixClassName}btn`);

            // SD-5153: Check if enableMessageNavigation is true, then focus on the first chat section
            if (this.$store.state.enableMessageNavigation) {
                let chatSection = jQuery(`.${this.$store.state.prefixClassName}chatBody main section[tabindex="0"]`);
                if (chatSection.length > 0) {
                    let firstFocusableSection = <HTMLElement>chatSection[0];
                    firstFocusableSection.focus();
                    return;
                }
            }

            // Else, continue with the normal flow of focusing on the first button
            if (webchatSectionBtn.length > 0) {
                let firstFocusableSectionButton = <HTMLElement>webchatSectionBtn[0];
                firstFocusableSectionButton.focus();
            }
            else {
                if (!this.$store.state.disableInput) {
                    if (jQuery(`button.${this.$store.state.prefixClassName}info`).is(":visible")) {
                        jQuery(`button.${this.$store.state.prefixClassName}info`).focus();
                    }
                    else if (jQuery(`button.${this.$store.state.prefixClassName}camera`).is(":visible")) {
                        jQuery(`button.${this.$store.state.prefixClassName}camera`).focus();
                    }
                    else {
                        jQuery(`input.${this.$store.state.prefixClassName}textInput`).focus();
                    }
                }
            }
        } catch (ex) {
            console.log("[main.ts] An error has occurred \n-> Inside focusFirstElementOFChatPage -> Error: ", ex);
        }
    }

    /**
     * The function `focusLastElementOFChatPage()` is used to set focus on the last element of the chat
     * page, either a send button or a text input, depending on the state of the application.
     */
    focusLastElementOFChatPage() {
        try {
            if (!this.$store.state.disableInput) {
                if (jQuery(`button.${this.$store.state.prefixClassName}send`).is(":visible")) {
                    jQuery(`button.${this.$store.state.prefixClassName}send`).focus();
                } else {
                    jQuery(`input.${this.$store.state.prefixClassName}textInput`).focus();
                }
            } else {
                let webchatSectionBtn = jQuery(`.${this.$store.state.prefixClassName}standalone section .${this.$store.state.prefixClassName}btn`);
                if (webchatSectionBtn.length > 0) {
                    let lastFocusableSectionButton = <HTMLElement>webchatSectionBtn[webchatSectionBtn.length - 1];
                    lastFocusableSectionButton.focus();
                }
            }
        } catch (ex) {
            console.log("[main.ts] An error has occurred \n-> Inside focusLastElementOFChatPage -> Error: ", ex);
        }
    }


    listenEvents() {
        __vueEvent.once(EVENTS.SetConfig, (config: IConfig) => {
            this.startSignalr();
            this.hideTagLine = config.hideTagLine;
        })
        __vueEvent.on(EVENTS.NewMessage, () => {
            if (isMobile.any()) {
                if (typeof jQuery != 'undefined')
                    jQuery(`.${this.$store.state.prefixClassName}chatBody main section`).last().focus();
            } else {
                __vueEvent.emit(EVENTS.FocusInputArea);
            }
            if (this.$store.state.maintainState) {
                StorageHelper.set(`${__maintainStateTime}${this.$store.state.pageId}`, new Date().toUTCString());
            } else if (StorageHelper.get(`${__maintainStateTime}${this.$store.state.pageId}`) != null) {
                StorageHelper.remove(`${__maintainStateTime}${this.$store.state.pageId}`);
            }
        })
        __vueEvent.on(SIGNALR_STATUS.Disconnected, () => {
            this.$store.commit(STORE_MUTATION.SetBannerText, "Connecting...");
            this.$store.commit(STORE_MUTATION.SetShouldShowBanner, true);
        })
        __vueEvent.on(SIGNALR_STATUS.Connected, () => {
            this.$store.commit(STORE_MUTATION.SetShouldShowBanner, false);
        })
        __vueEvent.on(EVENTS.RemoveAllButtons, () => {
            this.$store.commit(STORE_MUTATION.RemoveAllButtons);
        })
        __vueEvent.on(EVENTS.UrlOpenedInIFrame, () => {
            // if the settings.browserTarget is "iframe"
            // This means url has been opened in a iframe.
            // So now we will show the Header for IFrame w/ return to chat title
            this.hideIFrameHeader = false;

            // As the header is shown again, emit event one more time after a delay
            if (this.$store.state.isHideTitleBar) {
                setTimeout(() => {
                    __vueEvent.emit(EVENTS.UrlOpenedInIFrameFromMain);
                }, 200);
            }
        })
        __vueEvent.on(EVENTS.HideCloseIFrameIcon, () => {
            // Close the Header for IFrame w/ return to chat title
            this.hideIFrameHeader = true;
        });
        __vueEvent.once(SIGNALR_STATUS.Connecting, () => {
            console.log(`[x] Trying to connect to SignalR...`);
        });
        __vueEvent.once(SIGNALR_STATUS.Connected, async () => {
            console.log(`[x] SignalR Connected`);

            const service = new ChatService();
            await service.logPageInformation(this.$store.state.pageId, 14);

            // If the new message processing is false, then do not fetch the welcome message
            if (!store.state.isNewMessageProcessing || store.state.skipWelcomeMessageOnURLInput) return;
            console.log(`[x] Requesting welcome message...`);
            await this.fetchWelcomeMessage();
            console.log(`[x] Welcome message response received!`);
            await this.fetchMaintainStateMessages();

        });
    }

    /**
     * The function adds a welcome message to a store in the application.
     * @param {string} [message] - The `message` parameter is a string that represents a JSON object.
     * It is optional and has a default value of an empty string.
     */
    addWelcomeMsg(message: string = "") {
        try {
            const welcomeMessage = JSON.parse(message);
            store.commit(STORE_MUTATION.AddMessage, {
                type: MESSAGE_TYPE.Bot,
                contents: welcomeMessage,
                id: welcomeMessage.recordInfo.messageCacheId
            } as IMessage);
        } catch (ex) { }
    }

    /**
     * The function is an asynchronous function that fetches a welcome message from
     * a ChatService and adds it to the current instance.
     */
    async fetchWelcomeMessage() {
        try {
            const service = new ChatService();

            // This is to get the welcome message from the EBM for backward compatibility
            const welcomeMsgCfg: IConfig = await service.getWelcomeMessage();
            this.$store.commit(STORE_MUTATION.SetShowWelcomeBanner, false);

            // This is to handle the case for backward compatibility for welcome message
            if (welcomeMsgCfg && !Util.isNullOrEmpty(welcomeMsgCfg.welcomeMessage)) {
                this.addWelcomeMsg(welcomeMsgCfg.welcomeMessage);
            }
        } catch (ex) {
            //console.log(ex);
            this.$store.commit(STORE_MUTATION.SetShowWelcomeBanner, false);
        }
    }

    /**
     * The function is an asynchronous function that fetches maintain state messages from
     * a ChatService and adds it to the current instance.
     */
    async fetchMaintainStateMessages() {
        try {
            const isMaintainState = StorageHelper.get(`${__maintainState}${this.$store.state.pageId}`) != null;
            if (this.$store.state.maintainState && isMaintainState) {
                console.log(`[x] Maintain state is ON. Requesting for maintain state messages...`);
                store.commit(STORE_MUTATION.SetIsMaintainStateMessages, true);
                store.commit(STORE_MUTATION.SetIsMessagesRestored, true);
                const msgs = await getMessageFromServer(
                    0,
                    CACHE_ID_TYPE.BeforeMessageCacheId,
                    false,
                    this.$store.state.minimumClientVersion || "",
                    `main.ts:fetchMaintainStateMessages`
                );
                console.log(`[x] Request for maintain state messages received!`);
            }
        } catch (ex) {
            //console.log(ex);
            store.commit(STORE_MUTATION.SetIsMaintainStateMessages, false);
        }
    }

    async setUserId() {
        // Update the WebChat application to pass the External Id Source to ebm.
        // When you generate the id automatically, set to 2 (Satisfi)
        // When you are using the client supplied id from the URL, set to 1 (Client)

        let extId = getQueryStringValue('extid');
        if (Util.isNullOrEmpty(extId)) {
            var headerInfo = satisfiLabsGLobal && satisfiLabsGLobal.HeaderInfo ?
                Util.validateAndParsePayload(satisfiLabsGLobal.HeaderInfo) : null;
            if (headerInfo && headerInfo.extid) {
                extId = headerInfo.extid;
                //When you generate the id from header, set to 3 (Client)
                store.commit(STORE_MUTATION.SetUserIdSourceTypeId, 3);
            }
            else {
                extId = getUserId();
                //When you generate the id automatically, set to 2 (Satisfi)
                store.commit(STORE_MUTATION.SetUserIdSourceTypeId, 2);
            }
        } else {
            //the client supplied id from the URL, set to 3 (Client)
            store.commit(STORE_MUTATION.SetUserIdSourceTypeId, 3);
        }
        store.commit(STORE_MUTATION.SetUserId, extId);
    }

    /**
     * This method is used to set the cf header value in the store.
     * SD-3539
     */
    async setCFHeader() {
        try {
            let cfHeader = getQueryStringValue('cf');
            if (Util.isNullOrEmpty(cfHeader)) {
                var headerInfo = satisfiLabsGLobal && satisfiLabsGLobal.HeaderInfo ?
                    Util.validateAndParsePayload(satisfiLabsGLobal.HeaderInfo) : null;
                if (satisfiLabsGLobal && headerInfo &&  headerInfo.cf) {
                    cfHeader = headerInfo.cf;
                } else {
                    cfHeader = '';
                }
            }
            store.commit(STORE_MUTATION.SetCFHeader, cfHeader || '');

        } catch (ex) {
            //console.log(ex);
        }
    }

    async startSignalr() {
        await installJquery();
        await installSignalr();
        new SignalrHandler().start();
    }

}
